import { useContext } from 'react'

import { UserDataContext } from '@components/user_data_provider'

export const useUserData = () => useContext(UserDataContext)
